/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 */


document.addEventListener("DOMContentLoaded", function() {

  document.addEventListener('change', function(e){
    var el = e.target;

    if(el.classList.contains('main_check')) {

      var lineItemsCheckbox = el.closest('table').querySelectorAll('.line-item--check');
      if(el.checked) {
        lineItemsCheckbox.forEach(function(checkbox) {
          checkbox.checked = true;
        });
      } else {
        lineItemsCheckbox.forEach(function(checkbox) {
         checkbox.checked = false;
        });
      }
    }
  });

  document.addEventListener('click', function(e){
  	var el = e.target;


    if(el.classList.contains('removeSelectedItems') || el.closest('.removeSelectedItems')) {
      if(!el.classList.contains('removeSelectedItems')) {
      	el = el.closest('.removeSelectedItems');
      }
       e.preventDefault();

      var lineItemsCheckbox = el.closest('.cart-wrapper').querySelectorAll('.line-item--check');
      if(lineItemsCheckbox.length) {

        var itemsArray = [];
        var qty = 0;
        var data = { updates: {} };

        lineItemsCheckbox.forEach(function(checkbox) {
          if(checkbox.checked == true) {
          	var lineItemId = checkbox.getAttribute('data-variant-id');
            itemsArray.push(lineItemId);
          }
        });



        var moveAlong = function() {
          if(itemsArray.length){ 
            // If we still have requests in the queue, let's process the next one.
            var request = itemsArray.shift();
            var data = 'id='+ request + '&quantity=0';
			jQuery.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: data,
              success: function(res){
                debugger;
                moveAlong();
              },
              error: function(){
                // if it's not last one Move Along else update the cart number with the current quantity
                if (itemsArray.length){
                  moveAlong()
                } else {
                  location.reload();
                }
              }
            });
          }else{
            location.reload();
          }

        };
        if(itemsArray.length){ 
          moveAlong();
        }
      }
    }
  });

});

/* CARBONE — PRODUCCIÓN: promo controlada + prioridad permanente por disponibilidad. */
(function () {
  'use strict';

  var COMPATIBILITY_FLAG = 'carbone_sabado_test_mode';
  var ASSET_VERSION = '20260821-production-v6-stock-tail-lock';

  function control() {
    return window.CarboneSaturdayControl || {};
  }

  function loadAsset(filename, marker) {
    if (document.querySelector('script[data-carbone-module="' + marker + '"]')) return;

    var current = document.currentScript;
    if (!current || !current.src) {
      var scripts = document.querySelectorAll('script[src*="/assets/custom.js"]');
      current = scripts.length ? scripts[scripts.length - 1] : null;
    }
    if (!current || !current.src) return;

    var assetBase = current.src.split('?')[0];
    var src = assetBase.replace(/custom\.js$/, filename);
    if (src === assetBase) return;
    src += '?v=' + encodeURIComponent(ASSET_VERSION);

    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.setAttribute('data-carbone-module', marker);
    document.head.appendChild(script);
  }

  function clearCompatibilityState() {
    try { sessionStorage.removeItem(COMPATIBILITY_FLAG); } catch (storageError) {}
  }

  function initCarboneSaturdaySystem() {
    var cfg = control();

    /* PERMANENTE: el orden disponibles → agotados de YATO/HOTECHE no depende de la promo,
       de la fecha, del apagado de emergencia ni del tipo de cliente. */
    loadAsset('carbone-brand-stock-order.js', 'carbone-global-stock-order-production');

    /* Solo los módulos del 10% dependen del control promocional. */
    if (!cfg.systemEnabled || cfg.emergencyOff || cfg.specialPriceCustomer || !cfg.campaignActive) {
      clearCompatibilityState();
      return;
    }

    /* Compatibilidad interna con el visual previamente aprobado. No habilita ningún modo de prueba visible. */
    try { sessionStorage.setItem(COMPATIBILITY_FLAG, '1'); } catch (storageError) {}

    loadAsset('carbone-saturday-visual.js', 'carbone-saturday-visual-production');
    loadAsset('carbone-saturday-pdp.js', 'carbone-saturday-pdp-production');

    if (String(cfg.discountCode || '').trim()) {
      loadAsset('carbone-saturday-checkout.js', 'carbone-saturday-checkout-production');
    }
  }

  try {
    initCarboneSaturdaySystem();
  } catch (error) {
    // Los módulos personalizados nunca deben impedir el funcionamiento normal de la tienda.
  }
})();

/* CARBONE — YATO/HOTECHE: el orden manual de Shopify es autoritativo para mantener agotados al fondo. */
(function () {
  'use strict';

  var path = window.location.pathname.replace(/\/+$/, '');
  var targetCollections = {
    '/collections/yato-ferreteria': true,
    '/collections/tienda-hoteche': true
  };

  if (!targetCollections[path]) return;

  /* Un sort_by explícito (por ejemplo best-selling) anula el orden MANUAL de la colección.
     Se elimina únicamente en estas dos colecciones y se conservan filtros, paginación y demás parámetros. */
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.has('sort_by')) {
      params.delete('sort_by');
      var query = params.toString();
      window.location.replace(path + (query ? '?' + query : '') + window.location.hash);
      return;
    }
  } catch (urlError) {}

  function lockSortControl() {
    var sortControl = document.querySelector('.collection__toolbar-item--sort');
    if (!sortControl) return;
    sortControl.style.display = 'none';
    sortControl.setAttribute('aria-hidden', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockSortControl);
  } else {
    lockSortControl();
  }

  document.addEventListener('shopify:section:load', lockSortControl);
})();

/* CARBONE — colecciones visuales protegidas: mostrar únicamente productos en existencia. */
(function () {
  'use strict';

  var path = window.location.pathname.replace(/\/+$/, '');
  var stockOnlyCollections = {
    '/collections/sabados-yato-hoteche': true,
    '/collections/nuevos-productos': true
  };

  if (!stockOnlyCollections[path]) return;

  try {
    var params = new URLSearchParams(window.location.search);
    var availability = params.getAll('filter.v.availability');

    if (availability.length !== 1 || availability[0] !== '1') {
      params.delete('filter.v.availability');
      params.append('filter.v.availability', '1');
      var query = params.toString();
      window.location.replace(path + (query ? '?' + query : '') + window.location.hash);
    }
  } catch (urlError) {
    // Si el navegador no soporta URLSearchParams, la colección sigue funcionando normalmente.
  }
})();
